<form class="u-bt u-bt--grey u-pt30 " [formGroup]="controlForm">
  <div class="row">
    <div class="col-md-12 u-mb30">
      <h2 class="txt txt--section">
       {{formNumber}}. Registro de lugar y equipo
      </h2>
      <small>Selecciona los campos asosiados al lugar y equipo de la infracción.</small>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <app-select
          title="Sitio"
          placeholder="Selecciona"
          [options]="assetList"
          [controlForm]="assetId"
        ></app-select>
        <!-- <label for="assetId" class="label">
          Sitio
        </label>
        <select name="assetId" id="assetId" formControlName="assetId">
          <option value="">Selecciona</option>
          <ng-container *ngFor="let asset of assetList">
            <option [value]="asset.id">{{asset.shortName}}</option>
          </ng-container>
        </select> -->
      </div>
    </div>

    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <app-select title="Zona" [controlForm]="zoneId" [options]="zoneList"
          placeholder="Selecciona"></app-select>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <app-select title="Tipo de equipo" [controlForm]="vehicleTypeId" [options]="vehicleTypeList"
          placeholder="Buscar tipo de vehículo"></app-select>
      </div>
    </div>
    <div class="col-md-4">
      <div class="form form--required u-mb50">
        <label for="patent" class="label">
          Patente del equipo
        </label>
        <input name="patent" id="patent" type="text" placeholder="Ej: LLLL11*" formControlName="patent"
          autocomplete="off">
        <h6 class="form__info">
          *Formato sin caracteres especiales.
        </h6>
      </div>
    </div>
  </div>
</form>
